<template>
  <div class="container">
      <div 
        :class="`tab interactive ${selected==tab?'selected':''}`" 
        v-for="tab in tabs" 
        :key="tab"
        @click="change(tab)"
        >
          {{tab}}
      </div>
  </div>
</template>

<script>
export default {
    data(){
         return{
             tabs:[
                 'Contenido',
                 'Estilos',
                 'Cuenta',
             ],
             selected:"Contenido"
         }
    },
    methods:{
        change(tab){
            this.selected = tab
            this.$emit("changeTab",tab)
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/vars.scss';
.container{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin:5px 0;
    .tab{
        border: solid 1px $light-grey;
        border-radius:10px;
        font-family: Montserrat;
        width: 25%;
        padding: 5px 0px;
        color: $dark-grey;
        font-weight: bold;  
        letter-spacing: .5px;

        transition: background 0.2s ease-in 0s,
                    color 0.2s  ease-in 0s; 

        &.selected{
            background: $dark-grey;
            color:white;
            border:none;
        }
    }
}

</style>